import './bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

const pinia = createPinia();
const app   = createApp(App);

if (import.meta.env.PROD) {
    const noop = () => {};
    Object.assign(console, { log: noop, info: noop, warn: noop, debug: noop });
}

app.use(pinia);
app.use(router);
app.mount('#app');

// Only register service worker in production — dev mode uses cache-first for JS
// which serves stale files on normal refresh
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}